import mark from 'markdown-it-mark';

export default mark;
